import React, { useMemo, useState } from 'react';
import { ScreenContainer, ContentFrame, LayoutControls, Button, RadioGroup, LayoutContentHeader, } from '@pinwheel/origami';
import { selectLoadedPlatform, selectMaskedAccounts, setSelectedMaskedAccountId, } from '../state/slices/slice-link-api';
import useLinkNavigate from '../hooks/useLinkNavigate';
import ModalHeader from '../components/ModalHeader';
import { tokenHasJob } from '../utils';
import isGuidedSwitch from '../LinkApiRouter/utils/guided-switch';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import TitleFrame from '../LinkApiRouter/components/TitleFrame';
import { selectFeatureFlags, selectLinkTokenPayload, } from '../state/slices/slice-link-params';
import useAmountOrPercentageSupported from '../views/AmountSelection/FullSwitchAndMore/hooks/useAmountOrPercentageSupported';
import { useAppDispatch, useAppSelector } from '../state';
import { getAccountSelectionTextFromMaskedAccount } from '../utils/account-selection';
import eventQueue from '../events/queue';
var AccountSelection = function () {
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var loadedPlatform = useAppSelector(selectLoadedPlatform);
    var amountOrPercentageSwitchSupported = useAmountOrPercentageSupported();
    var featureFlags = useAppSelector(selectFeatureFlags);
    var maskedAccounts = useAppSelector(selectMaskedAccounts);
    var accountOptions = maskedAccounts.map(function (maskedAccount) { return ({
        label: getAccountSelectionTextFromMaskedAccount(maskedAccount),
        value: maskedAccount.id,
    }); });
    var _a = useState(accountOptions[0].value), selectedAccountId = _a[0], setSelectedAccountId = _a[1];
    var handleContinue = function () {
        dispatch(setSelectedMaskedAccountId(selectedAccountId));
        var accountData = maskedAccounts.find(function (x) { return x.id === selectedAccountId; });
        if (accountData)
            eventQueue.emit('select_account', { data: accountData });
        if (tokenHasJob(linkTokenPayload, 'direct_deposit_switch')) {
            if (isGuidedSwitch(loadedPlatform, featureFlags)) {
                navigate('/link-api/guided-switch-primer');
            }
            else if (linkTokenPayload.skipDepositConfirmation) {
                navigate('/link-api/dds');
            }
            else if (linkTokenPayload.disableDirectDepositSplitting ||
                !amountOrPercentageSwitchSupported) {
                navigate('/switch-confirmation');
            }
            else {
                navigate('/amount-selection');
            }
        }
    };
    var subtitle = useMemo(function () {
        return maskedAccounts.length > 1
            ? getLocalizedString('SELECT_ACCOUNT_SUBTITLE')
            : null;
    }, [getLocalizedString, maskedAccounts.length]);
    return (React.createElement(ScreenContainer, { "data-testid": "ddsAccountSelection" },
        React.createElement(ModalHeader, { showPlatformLogo: true, hideBackButton: true }),
        React.createElement(LayoutContentHeader, { sx: { padding: '0px' } },
            React.createElement(TitleFrame, { title: getLocalizedString('SELECT_ACCOUNT_TITLE'), subtitle: subtitle },
                React.createElement(React.Fragment, null))),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutControls, null,
                React.createElement(RadioGroup, { options: accountOptions, value: accountOptions[0].value, onChange: function (value) { return setSelectedAccountId(value); } }))),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { eventId: "AccountSelection-continue", onClick: handleContinue }, getLocalizedString('CONTINUE')))));
};
export default AccountSelection;
